import React from 'react'

import { Button } from '../../Button'

import {CtaOptionProps} from '../../../types/interfaces/ctaInterface'


export const CtaOption: React.FC<CtaOptionProps> = (props) => {
    return (
        <>
            <p>{props.description}</p>
            <Button {...props} />
        </>
    )
}
